import {
  type DocumentDomainSelectModel,
  DocumentId,
  ProjectUrn,
} from '@mntn-dev/domain-types'

import { MockModel } from './mock-model.ts'

export const MockDocument = MockModel<DocumentDomainSelectModel>(
  ({
    documentId = DocumentId(),
    folderUrn = ProjectUrn(),
    template = 'quickframe-sow',
    version = 1,
    payload = {
      clientName: 'Test Client Inc.',
      basePackage: {
        packageName: 'Test Project',
        fee: 5000,
      },
      totalFees: 5000,
    },
  }) => {
    return {
      documentId,
      folderUrn,
      template,
      version,
      payload,
    } satisfies DocumentDomainSelectModel
  }
)
